var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('main', {
    attrs: {
      "id": "app"
    }
  }, [_vm.isBlockingNote && _vm.$route.name !== 'login' && !_vm.$store.state.newVersionAvailable ? _c('div', {
    staticClass: "temporary_note"
  }, [_c('div', {
    staticClass: "temporary_note__inner",
    domProps: {
      "innerHTML": _vm._s(_vm.note)
    }
  })]) : _vm._e(), _vm.$store.state.status ? _c('status-bar') : _vm._e(), _vm.$store.state.loading ? _c('div', {
    attrs: {
      "id": "loading"
    }
  }, [_c('scaling-squares-spinner', {
    attrs: {
      "animation-duration": 1200,
      "size": 60,
      "color": "#ab001c"
    }
  }), _c('div', {
    staticClass: "message"
  }, [_vm._v(" " + _vm._s(_vm.$store.state.loadingMessage ? _vm.$store.state.loadingMessage : "Loading...") + " ")])], 1) : _vm._e(), _c('transition', [_c('router-view')], 1), _vm.$store.state.newVersionAvailable ? _c('action-modal', {
    on: {
      "close-modal": _vm.dismissUpdate,
      "ok": _vm.handleApplyUpdate
    }
  }, [_c('h2', {
    staticClass: "title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("アップデートのお知らせ")]), _c('p', {
    staticClass: "text",
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v(" 新しいバージョンが利用可能です。今すぐ更新しますか？ ")])]) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };